<template>
  <div class="hero-navigation" :class="{inactive: show === false}">
    <SidebarMenu @clickSidebar="handleClickNavigation" :breadcrumb="breadcrumb" :userChoices="userChoices" :menuActive="this.menuActive" :operationNavigation="operationNavigation"/>

    <template v-if="menuActive === 1">
      <ChooseYourRoom @clickedTvRoom="onClickChooseYourRoom" :roomSelected="this.userChoices.roomSelected" />
    </template>
    <template v-if="this.menuActive === 2">
      <ChooseYourPassion :step="chooseYourPassionStep" @clickSelectPassion="onClickSelectPassion"
        @clickSelectFeature="onClickSelectFeature" :passionSelected="this.userChoices.passionSelected"
        :featureSelected="this.userChoices.featureSelected"
        :featuresByPassionSelected="this.featuresByPassionSelected" />
    </template>
    <template v-if="this.menuActive === 3">
      <ChooseInchesScreen @clickSelectInch="onClickSelectInch" :userChoices="this.userChoices" />
    </template>
    <template v-if="this.menuActive === 4">
      <ChoosePrice @clickSelectPrice="onClickSelectPrice" :priceSelected="this.userChoices.priceSelected"
        :userChoices="this.userChoices" />
    </template>

    <NavigationButtons @clickNavigation="handleClickNavigation" :menuActive="this.menuActive" />
  </div>
</template>

<script>
import SidebarMenu from '../components/SidebarMenu.vue';
import ChooseYourRoom from '../components/HeroNavigation/ChooseYourRoom.vue';
import ChooseYourPassion from '../components/HeroNavigation/ChooseYourPassion.vue';
import NavigationButtons from '../components/NavigationButtons.vue';
import ChooseInchesScreen from '../components/HeroNavigation/ChooseInchesScreen.vue';
import ChoosePrice from '../components/HeroNavigation/ChoosePrice.vue';
import passions from '../constants/passions';

import Vue from 'vue';

import { getFeaturesByPassion,getFilterFeaturesByPassion } from '../utils/dataHandler';


export default {
  name: "HeroNavigation",
  components: {
    SidebarMenu,
    ChooseYourRoom,
    ChooseYourPassion,
    NavigationButtons,
    ChooseInchesScreen,
    ChoosePrice,
  },
  props: ["sendAnalytics", "show", "menuActive", "userChoices", "quantityFilteredProducts", "products"],
  data() {
   
    return {
      chooseYourPassionStep: 1,
      featuresByPassionSelected: {},
      breadcrumb:{
        roomSelected: "Sala de estar",
        passionSelected:"",
        featureSelected:"",
        inchSelected:"",
        step:1
      },
      operationNavigation: "",
    }
  },
  computed: {},
  mounted() {
  },
  methods: {
    onClickChooseYourRoom(room) {
      this.$emit(
        'handleUserChoices',
        { filter: { room }, choices: { roomSelected: room } }
      );
    },

    onClickSelectPassion(passion) {
      const { featuresByPassion } = getFeaturesByPassion(passion);

      this.featuresByPassionSelected = featuresByPassion;

      this.$emit(
        'handleUserChoices',
        {
          filter: { passion },
          choices: { passionSelected: passion }
        }
      );
    },

    onClickSelectFeature(feature) {
      this.$emit(
        'handleUserChoices',
        {
          filter: {
            feature,
            passion: this.userChoices.passionSelected
          },
          choices: { featureSelected: feature }
        }
      );
    },

    onClickSelectInch(size) {
      this.$emit(
        'handleUserChoices',
        {
          filter: {
            size,
            feature: this.userChoices.featureSelected,
            passion: this.userChoices.passionSelected
          },
          choices: { inchSelected: size }
        }
      );
    },

    onClickSelectPrice(maxPrice) {
      const price = {
        min: parseInt(sessionStorage.getItem('min')),
        max: parseInt(maxPrice)
      }

      this.$emit(
        'handleUserChoices',
        {
          filter: {
            price,
            size: this.userChoices.inchSelected,
            feature: this.userChoices.featureSelected,
            passion: this.userChoices.passionSelected
          },
          choices: { priceSelected: price }
        }
      );
    },

    handleClickNavigation(operation) {
      
     
      if (!this.validateChoices(operation)) return;    

      this.operationNavigation = operation;

     this.handleSendAnalytics(operation);

     this.breadcrumbOperator(operation);
     if (this.menuActive === 2 && (operation === 'forward' && this.chooseYourPassionStep === 1) && this.userChoices.passionSelected === "todos") {
        this.chooseYourPassionStep = 3;
        this.$emit('setMenuActive', 3);
        return;
      }

      if (this.menuActive === 3 && (operation === 'goBack' && this.chooseYourPassionStep === 3) && this.userChoices.passionSelected === "todos") {
 
        this.chooseYourPassionStep = 1;
        this.$emit('setMenuActive', 2);
        return;
      }


      if (this.menuActive === 2 && (operation === 'goBack' && this.chooseYourPassionStep === 2)) {
  
        this.chooseYourPassionStep = 1;
        return;
      }
      
      if (this.menuActive === 2 && (operation === 'forward' && this.chooseYourPassionStep === 1)) {
       
        this.chooseYourPassionStep = 2;
        document.getElementById(`menu${this.menuActive}`)
          .scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        return;
      }
     
      
      // correção do goBack para voltar ao step 2 da passion - part 1
      if (operation === 'goBack'){
        if (this.menuActive === 3) {
          this.chooseYourPassionStep = 2;
        }
      }
      
      if (operation === 'forward') {
        // correção do goBack para voltar ao step 2 da passion - part 2
        if (this.menuActive === 1){
          this.chooseYourPassionStep = 1;
        }
      }
     
      this.$emit('clickNavigation', operation);
    },

    handleSendAnalytics(operation){
      const menusIndex = [
        "ambiente", 
        "Preferências-atividade", 
        "Preferências-funcionalidade", 
        "tamanho",
        "preco"
      ];

      const operationsIsForward = operation === 'forward';

      if (this.menuActive === 1) {
        window.click_s_evar_event('o', '26', 'qa-ambiente', 'click', 'avancar-' + this.userChoices.roomSelected.adobeAnalytics);

        window.dataLayer.push({
          event: `gtm.${operationsIsForward ? 'avancar' : 'voltar'}`,
          target: "gtm-more",
          action: "navigation",
          menu_origem: 'ambiente',
          menu_destino: `${operationsIsForward ? menusIndex[this.menuActive] : 'tela-inicial'}`,
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

        if(operationsIsForward){
          let filteredProducts = '';

          this.products.map((product) => {
            filteredProducts += product.displayName + ','
          });

          window.dataLayer.push({
            event: `gtm.tvs_filtradas`,
            target: "gtm-more",
            action: "navigation",
            menu_origem: 'ambiente',
            menu_destino: menusIndex[this.menuActive],
            modelo_TV: filteredProducts,
            escolha_feature: this.userChoices.roomSelected.adobeAnalytics
            // label: "target-properties",
            // value: 5000,
            // noninteraction: "interaction-type",
            // TransactionID: numRandomicoUnico,
          });
        }

        // Analytics Samsung - Facebook
        switch(this.userChoices.roomSelected.name){
          
          case 'Sala de estar':
            window.fbq('trackCustom', 'Simulador_SalaTV');
            break;
          
          case 'Quarto':
            window.fbq('trackCustom', 'Simulador_Quarto');
            break;
        }

      }

      if (this.menuActive === 2 && (!operationsIsForward && this.chooseYourPassionStep === 2)) {
        window.dataLayer.push({
          event: "gtm.voltar",
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[2],
          menu_destino: menusIndex[1],
        });
      }

      if (this.menuActive === 2 && (operationsIsForward && this.chooseYourPassionStep === 1)) {

        var passionAnalytics = passions.find(passion => passion.title === this.userChoices.passionSelected)

        window.click_s_evar_event('o', '26', 'qa-preferencias-atividade', 'click', 'avancar-' + passionAnalytics.adobeAnalyticsPassions);

        window.dataLayer.push({
          event: "gtm.avancar",
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[1],
          menu_destino: menusIndex[2],
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

        // Analytics Samsung - Facebook
        switch(passionAnalytics.title){
          
          case 'sports':
            window.fbq('trackCustom', 'Simulador_Esportes');
            break;
          
          case 'movies':
            window.fbq('trackCustom', 'Simulador_Filmes');
            break;
        }

        let filteredProducts = '';

        this.products.map((product) => {
          filteredProducts += `${product.displayName + ','}`
        });

        window.dataLayer.push({
          event: `gtm.tvs_filtradas`,
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[1],
          menu_destino: menusIndex[2],
          modelo_TV: filteredProducts,
          escolha_feature: passionAnalytics.adobeAnalyticsPassions
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
        
      }

      if (this.menuActive === 2 && (!operationsIsForward && this.chooseYourPassionStep === 1)) {
        window.dataLayer.push({
          event: "gtm.voltar",
          target: "gtm-more",
          action: "navigation",
          menu_origem: 'Preferências-atividade',
          menu_destino: 'ambiente',
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
      }

      if (this.menuActive === 2 && (operationsIsForward && this.chooseYourPassionStep === 2)) {

        var passion = passions.find(passion => passion.title === this.userChoices.passionSelected);

        var features = passion.featuresByPassion.find(feature => feature.name === this.userChoices.featureSelected);

        window.click_s_evar_event('o', '26', 'qa-preferencias-funcionalidade', 'click', 'avancar-' + features.adobeAnalyticsFeatures);

        window.dataLayer.push({
          event: "gtm.avancar",
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[this.menuActive],
          menu_destino: menusIndex[this.menuActive + 1],
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

        let filteredProducts = '';

        this.products.map((product) => {
          filteredProducts += product.displayName + ','
        });

        window.dataLayer.push({
          event: `gtm.tvs_filtradas`,
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[this.menuActive],
          menu_destino: menusIndex[this.menuActive + 1],
          modelo_TV: filteredProducts,
          escolha_feature: features.adobeAnalyticsFeatures
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
        
      }

      if (this.menuActive === 3) {
        
        var inches = this.userChoices.inchSelected;
        
        if(operationsIsForward){
          window.click_s_evar_event('o', '26', 'qa-preferencias-tamanho', 'click', 'avancar-' + inches[0] + "-" + inches[1]);
        }

        window.dataLayer.push({
          event: `gtm.${operationsIsForward ? 'avancar' : 'voltar'}`,
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[this.menuActive],
          menu_destino: `${operationsIsForward ? menusIndex[this.menuActive + 1] : menusIndex[this.menuActive - 1]}`,
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

        if(operationsIsForward){
          let filteredProducts = '';

          this.products.map((product) => {
            filteredProducts += product.displayName + ','
          });

          window.dataLayer.push({
            event: `gtm.tvs_filtradas`,
            target: "gtm-more",
            action: "navigation",
            menu_origem: menusIndex[this.menuActive],
            menu_destino: menusIndex[this.menuActive + 1],
            modelo_TV: filteredProducts,
            escolha_feature: inches[0] + "-" + inches[1]
            // label: "target-properties",
            // value: 5000,
            // noninteraction: "interaction-type",
            // TransactionID: numRandomicoUnico,
          });
        }
      }
      
      if (this.menuActive === 4) {
        
        var price = this.userChoices.priceSelected;
        
        if(operationsIsForward){
          window.click_s_evar_event('o', '26', 'qa-preferencias-preco', 'click', 'avancar-' + price.min + "-" + price.max);
        }
        
        window.dataLayer.push({
          event: `gtm.${operationsIsForward ? 'avancar' : 'voltar'}`,
          target: "gtm-more",
          action: "navigation",
          menu_origem: menusIndex[this.menuActive],
          menu_destino: `${operationsIsForward ? 'resumo-final' : menusIndex[this.menuActive - 1]}`,
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

        if(operationsIsForward){
          let filteredProducts = '';

          this.products.map((product) => {
            filteredProducts += product.displayName + ','
          });

          window.dataLayer.push({
            event: `gtm.tvs_filtradas`,
            target: "gtm-more",
            action: "navigation",
            menu_origem: menusIndex[this.menuActive],
            menu_destino: 'resumo-final',
            modelo_TV: filteredProducts,
            escolha_feature: price.min + "-" + price.max
            // label: "target-properties",
            // value: 5000,
            // noninteraction: "interaction-type",
            // TransactionID: numRandomicoUnico,
          });
        }
      }
    },

    validateChoices(operation) {
      if (this.menuActive === 2 && (operation === 'forward' && this.chooseYourPassionStep === 1)) {

        if (!this.userChoices.passionSelected) {
          Vue.$toast.open({
            message: 'Selecione uma atividade para prosseguir',
            type: 'error',
            position: 'bottom-right'
          });
          return false;
        }
      }

      if (this.menuActive === 2 && (operation === 'forward' && this.chooseYourPassionStep === 2)) {

        if (!this.userChoices.featureSelected) {
          Vue.$toast.open({
            message: 'Selecione uma funcionalidade para prosseguir',
            type: 'error',
            position: 'bottom-right'
          });
          return false;
        }
      }


      // if (this.menuActive === 3 && (operation === 'goBack' && this.chooseYourPassionStep === 2)) {

      //   //window.click_s_evar_event('o', '26', 'qa-preferencias-funcionalidade', 'click', 'avancar-' + this.userChoices.featureSelected.adobeAnalytics);
      //   console.log(this.userChoices.featureSelected);
      //   console.log('voltei')
      //   this.chooseYourPassionStep = 2;

      //   // if (!this.userChoices.featureSelected) {
      //   //   Vue.$toast.open({
      //   //     message: 'Selecione uma funcionalidade para prosseguir',
      //   //     type: 'error',
      //   //     position: 'bottom-right'
      //   //   });
      //   //   return false;
      //   // }
      // }

      Vue.$toast.clear();


      return true;
    },

    breadcrumbOperator(operation){
     
      if(operation == "forward"){
        if(this.userChoices.passionSelected === "todos"){
          this.breadcrumb.featureSelected = "";
          this.breadcrumb.step = 3;
        }
     
        if(this.menuActive == 2){
          this.breadcrumb.step += 0.5;
        }else{
          this.breadcrumb.step++;
        }
        
        if(this.breadcrumb.step == 2.5 && this.userChoices.featureSelected == ""){
          this.breadcrumb.step = 2.5;
        }

      }else{
     
        if(this.menuActive == 4){
          
          this.breadcrumb.step--;
          return;
        }

        if(this.menuActive == 3){
          
          this.breadcrumb.step -= 0.5;
          return;
        }
        
        if(this.menuActive == 2 && Number.isInteger(this.breadcrumb.step) == false){
      
          this.breadcrumb.step -= 0.5;
          return;
        } 

        if(this.menuActive == 2 && Number.isInteger(this.breadcrumb.step) == true){
        
          this.breadcrumb.step--;
          
        }
        
      }

      const {displayName, featuresByPassion} = getFilterFeaturesByPassion(this.userChoices.passionSelected); 
        
      this.breadcrumb.roomSelected     = this.userChoices.roomSelected.name;
      this.breadcrumb.passionSelected  = displayName;
       
      if(this.userChoices.featureSelected){
        const featureBreadcrumbName = featuresByPassion.find((feature)=> feature.name == this.userChoices.featureSelected);
        
        if(featureBreadcrumbName){
          this.breadcrumb.featureSelected  = featureBreadcrumbName.breadcrumbName;
        }
      
      }

      this.breadcrumb.inchSelected     = this.userChoices.inchSelected;
    }
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.hero-navigation {
  display: flex;

  position: relative;
  flex-direction: column;
  width: 100%;
}

@media (max-width: $bp-mobile){

  .setMobileHeroNavigation{
    margin-top: -75px;
    z-index: 0;
  }
}

.inactive {
  display: none;
}
</style>
